module.exports = __webpack_public_path__ + "img/ghlgl.5d88218a.png";